import PrivateRoute, { Router } from 'components/app-layout/PrivateRoute';

import FieldsGrid from '../components/Grid';
import { FieldProvider } from '../store';

import FieldFormLayout from './Form';

export default function FieldsGridLayout() {
  return <FieldProvider>
    <FieldsGrid />
    <Router>
      <PrivateRoute path={["/path/fields/add", "/path/fields/:id"]} component={FieldFormLayout} />
    </Router>
  </FieldProvider>
}
